import Vue from 'vue';
import Router from 'vue-router';
import storage from './sdk/common/Storage';
import i18n from '@/lang';
import store from './store';
import VcardLayout from '@/platform/VcardLayout.vue';

Vue.use(Router);
const originalPush = Router.prototype.push;
Router.prototype.push = function push (location) {
  return (originalPush.call(this, location) as any).catch(err => { console.log(err); });
};

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'main',
      component: () => import(/* webpackChunkName: "main" */'./platform/index.vue'),
      children: [
        {
          path: '',
          name: 'home',
          component: () => import(/* webpackChunkName: "home" */'./views/InsHome.vue')
        },
        {
          path: '/cms/404',
          name: '404',
          component: () =>
            import(/* webpackChunkName: "product" */ './components/service/InsNotFound.vue')
        },
        {
          path: '/building',
          name: 'building',
          component: () =>
            import(/* webpackChunkName: "product" */ './components/service/InsBuilding.vue')
        },
        {
          path: '/product/detail/:id',
          name: 'ProductsDetail',
          component: () =>
            import(
              /* webpackChunkName: "product" */ './views/InsProductDetail.vue'
            )
        },
        {
          path: '/product/search/:key',
          name: 'productSearch',
          component: () =>
            import(/* webpackChunkName: "product" */ './views/InsProductSearchN.vue'),
          props: (route) => ({
            attrs: route.query.attrs,
            catalogs: route.query.catalogs,
            type: route.query.type
          }),
          meta: {
            title: 'Product',
            keepAlive: true // 标记该组件需要缓存
          }
        },
        {
          path: '/product/cat/:catId?',
          name: 'productCat',
          component: () =>
            import(/* webpackChunkName: "product" */ './views/InsProductCat.vue')
        },
        // 会员中心路由开始
        {
          path: '/account/login',
          name: 'login',
          component: () =>
            import(
              /* webpackChunkName: "account" */ './components/business/account/InsLoginN.vue'
            )
        },
        {
          path: '/account/register',
          name: 'register',
          component: () =>
            import(
              /* webpackChunkName: "account" */ './components/business/account/InsLoginN.vue'
            )
        },
        {
          path: '/account/registerSuccess',
          name: 'registerSuccess',
          component: () =>
            import(
              /* webpackChunkName: "account" */ './components/business/account/InsRegisterSuccess.vue'
            )
        },
        {
          // 个人中心
          path: '/account',
          name: 'memberCenter',
          meta: {
            requiresAuth: true // 是否进行登录验证
          },
          component: () =>
            import(
              /* webpackChunkName: "account" */ './components/business/account/InsMemberCenter.vue'
            ),
            children: [{
              // 个人信息
              path: 'memberInfo',
              name: 'memberInfo',
              meta: {
                requiresAuth: true // 是否进行登录验证
              },
              component: () =>
              import(
                /* webpackChunkName: "account" */ './components/business/account/InsMemberInfo.vue'
              )
            },
            {
              path: 'modifyPassword',
              name: 'modifyPassword',
              meta: {
                requiresAuth: true // 是否进行登录验证
              },
              component: () =>
                import(
                  /* webpackChunkName: "account" */ './components/business/account/InsModifyPassword.vue'
                )
            },
            {
              path: 'deliveryAddress',
              name: 'deliveryAddress',
              meta: {
                requiresAuth: true // 是否进行登录验证
              },
              component: () =>
                import(
                  /* webpackChunkName: "account" */ './components/business/account/InsDeliveryAddress.vue'
                )
            },
            {
              path: 'message',
              name: 'message',
              meta: {
                requiresAuth: true // 是否进行登录验证
              },
              component: () =>
                import(
                  /* webpackChunkName: "account" */ './components/business/account/InsMessage.vue'
                )
            },
            {
              path: 'ptxorder',
              name: 'ptxorder',
              meta: {
                requiresAuth: true // 是否进行登录验证
              },
              component: () =>
                import(
                  /* webpackChunkName: "account" */ './components/business/account/InsPtxOrder.vue'
                )
            },
            {
              path: 'ptxupload',
              name: 'ptxupload',
              meta: {
                requiresAuth: true // 是否进行登录验证
              },
              component: () =>
                import(
                  /* webpackChunkName: "account" */ './components/business/account/InsPtxUpload.vue'
                )
            },
            {
              path: 'CaseList/:id',
              name: 'CaseList',
              meta: {
                requiresAuth: true // 是否进行登录验证
              },
              component: () =>
                import(
                  /* webpackChunkName: "account" */ './components/siteBusiness/account/List/InsCaseList.vue'
                )
            },
            {
              path: 'BuyOrderDetail/:id/:type',
              name: 'BuyOrderDetail',
              meta: {
                requiresAuth: true // 是否进行登录验证
              },
              component: () =>
                import(
                  /* webpackChunkName: "account" */ './components/siteBusiness/account/Detail/InsBuyOrderDetail.vue'
                )
            },
            {
              path: 'DeliveryDetail/:id/:type',
              name: 'DeliveryDetail',
              meta: {
                requiresAuth: true // 是否进行登录验证
              },
              component: () =>
                import(
                  /* webpackChunkName: "account" */ './components/siteBusiness/account/Detail/InsDeliveryDetail.vue'
                )
            },
            {
              path: 'DeliveryOrderDetail/:id',
              name: 'DeliveryOrderDetail',
              meta: {
                requiresAuth: true // 是否进行登录验证
              },
              component: () =>
                import(
                  /* webpackChunkName: "account" */ './components/siteBusiness/account/Detail/InsDeliveryOrderDetail.vue'
                )
            },
            {
              path: 'EnquiryDetail/:id/:type',
              name: 'EnquiryDetail',
              meta: {
                requiresAuth: true // 是否进行登录验证
              },
              component: () =>
                import(
                  /* webpackChunkName: "account" */ './components/siteBusiness/account/Detail/InsEnquiryDetail.vue'
                )
            },
            {
              path: 'InviceInfoDetail/:id/:type',
              name: 'InviceInfoDetail',
              meta: {
                requiresAuth: true // 是否进行登录验证
              },
              component: () =>
                import(
                  /* webpackChunkName: "account" */ './components/siteBusiness/account/Detail/InsInviceInfoDetail.vue'
                )
            },
            {
              path: 'PackingDetail/:id/:type',
              name: 'PackingDetail',
              meta: {
                requiresAuth: true // 是否进行登录验证
              },
              component: () =>
                import(
                  /* webpackChunkName: "account" */ './components/siteBusiness/account/Detail/InsPackingDetail.vue'
                )
            },
            {
              path: 'QuotaDetail/:id/:type',
              name: 'QuotaDetail',
              meta: {
                requiresAuth: true // 是否进行登录验证
              },
              component: () =>
                import(
                  /* webpackChunkName: "account" */ './components/siteBusiness/account/Detail/InsQuotaDetail.vue'
                )
            }
          ]
        },
        {
          path: '/account/QuotaPrinting/:id/:type',
          name: 'QuotaPrinting',
          meta: {
            requiresAuth: true // 是否进行登录验证
          },
          component: () =>
            import(
              /* webpackChunkName: "account" */ './components/siteBusiness/account/Print/InsQuotaPrinting.vue'
            )
        },
        {
          path: '/account/BuyOrderPrinting/:id/:type',
          name: 'BuyOrderPrinting',
          meta: {
            requiresAuth: true // 是否进行登录验证
          },
          component: () =>
            import(
              /* webpackChunkName: "account" */ './components/siteBusiness/account/Print/InsBuyOrderPrinting.vue'
            )
        },
        {
          path: '/account/InviceInfoPrinting/:id/:type',
          name: 'InviceInfoPrinting',
          meta: {
            requiresAuth: true // 是否进行登录验证
          },
          component: () =>
            import(
              /* webpackChunkName: "account" */ './components/siteBusiness/account/Print/InsInviceInfoPrinting.vue'
            )
        },
        {
          path: '/account/DeliveryPrinting/:id/:type',
          name: 'DeliveryPrinting',
          meta: {
            requiresAuth: true // 是否进行登录验证
          },
          component: () =>
            import(
              /* webpackChunkName: "account" */ './components/siteBusiness/account/Print/InsDeliveryPrinting.vue'
            )
        },
        {
          path: '/account/PackingPrinting/:id/:type',
          name: 'PackingPrinting',
          meta: {
            requiresAuth: true // 是否进行登录验证
          },
          component: () =>
            import(
              /* webpackChunkName: "account" */ './components/siteBusiness/account/Print/InsPackingPrinting.vue'
            )
        },
        {
          path: '/account/ResetPwd/:id/:code',
          name: 'ResetPwd',
          component: () =>
            import(
              /* webpackChunkName: "account" */ './components/business/account/InsResetPwd.vue'
            )
        },
        {
          path: '/account/myFavorite',
          name: 'myFavorite',
          meta: {
            requiresAuth: true // 是否进行登录验证
          },
          component: () =>
            import(
              /* webpackChunkName: "account" */ './components/business/account/InsMyFavorite.vue'
            )
        },
        {
          path: '/account/myCoupon',
          name: 'myCoupon',
          meta: {
            requiresAuth: true // 是否进行登录验证
          },
          component: () =>
            import(
              /* webpackChunkName: "account" */ './components/business/account/InsMyCoupon.vue'
            )
        },
        {
          path: '/account/notification',
          name: 'notification',
          meta: {
            requiresAuth: true // 是否进行登录验证
          },
          component: () =>
            import(
              /* webpackChunkName: "account" */ './components/business/account/InsNotification.vue'
            )
        },
        {
          path: '/account/forgetPassword',
          name: 'forgetPassword',
          // meta: {
          //   requiresAuth: true // 是否进行登录验证
          // },
          component: () =>
            import(
              /* webpackChunkName: "account" */ './components/business/account/InsForgetPassword.vue'
            )
        },
        {
          path: '/account/points',
          name: 'points',
          meta: {
            requiresAuth: true // 是否进行登录验证
          },
          component: () =>
            import(
              /* webpackChunkName: "account" */ './components/business/account/InsPoints.vue'
            )
        },
        {
          path: '/order/List',
          name: 'OrderList',
          meta: {
            requiresAuth: true // 是否进行登录验证
          },
          component: () =>
            import(
              /* webpackChunkName: "account" */ './components/business/account/InsOrderList.vue'
            )
        },
        {
          path: '/order/detail/:id',
          name: 'detail',
          meta: {
            requiresAuth: true // 是否进行登录验证
          },
          component: () =>
            import(
              /* webpackChunkName: "account" */ './components/business/account/InsOrderDetail.vue'
            )
        },
        {
          path: '/order/evidence/:id',
          name: 'evidence',
          meta: {
            requiresAuth: true // 是否进行登录验证
          },
          component: () =>
            import(
              /* webpackChunkName: "account" */ './components/business/account/InsOrderEvidence.vue'
            )
        },
        {
          path: '/account/orderComment/:id',
          name: 'orderComment',
          meta: {
            requiresAuth: true // 是否进行登录验证
          },
          component: () =>
            import(
              /* webpackChunkName: "account" */ './components/business/account/InsAddComments.vue'
            )
        },
        {
          path: '/account/shoppingcart',
          name: 'shoppingcart',
          component: () =>
            import(
              /* webpackChunkName: "account" */ './views/InsShoppingcart.vue'
            )
        },
        {
          path: '/account/GetEnquiry',
          name: 'GetEnquiry',
          meta: {
            requiresAuth: true // 是否进行登录验证
          },
          component: () =>
            import(
              /* webpackChunkName: "account" */ './views/InsGetEnquiry.vue'
            )
        },
        {
          path: '/account/checkout',
          name: 'checkout',
          meta: {
            requiresAuth: true, // 是否进行登录验证
            onlyFrom: '/account/shoppingcart'
          },
          component: () =>
            import(
              /* webpackChunkName: "checkout" */ './views/InsCheckoutN.vue'
            )
        },
        {
          path: '/account/completeCheckout/:id',
          name: 'completeCheckout',
          component: () =>
            import(
              /* webpackChunkName: "checkout" */ './components/business/account/InsCompleteCheckout.vue'
            )
        },
        {
          path: '/account/EnquirySuccess',
          name: 'EnquirySuccess',
          component: () =>
            import(
            /* webpackChunkName: "rnp" */ './views/InsEnquirySuccess.vue'
            )
        },
        {
          path: '/cms/content/:id/:key?',
          name: 'cmsContent',
          component: () =>
            import(
              /* webpackChunkName: "cms" */ './components/business/cms/InsCmsContent.vue'
            )
        },
        {
          path: '/cms/contentN/:id',
          name: 'cmsContentN',
          component: () =>
            import(
              /* webpackChunkName: "cms" */ './components/business/cms/InsCmsContentN.vue'
            )
        },
        {
          path: '/cms/catDetail/:id',
          name: 'catDetail',
          component: () =>
            import(
              /* webpackChunkName: "cms" */ './components/business/cms/InsCatDetail.vue'
            )
        },
        {
          path: '/cms/search/:key',
          name: 'cmsSearch',
          component: () =>
            import(
              /* webpackChunkName: "cms" */ './views/CmsSearch.vue'
            )
        },
        {
          path: '/regnpay/plan/:id',
          name: 'rnpayPlan',
          component: () =>
          import(
            /* webpackChunkName: "rnpayPlan" */ './views/InsRNPayPlan.vue'
          )
        },
        {
          path: '/regnpay/form/:id',
          name: 'regnpay',
          component: () =>
          import(
            /* webpackChunkName: "rnp" */ './views/InsRegAndPay.vue'
          )
        },
        {
          path: '/regnpay/result/:id',
          name: 'regnpayResult',
          component: () =>
            import(
            /* webpackChunkName: "rnp" */ './views/InsRegAndPayResult.vue'
            )
        },
        {
          path: '/Payment/PaySuccess/:id',
          name: 'paymentResult',
          component: () =>
            import(
            /* webpackChunkName: "rnp" */ './views/InsPaySuccess.vue'
            )
        },
        {
          path: '/payment/PayFail/:id',
          name: 'paymentFail',
          component: () =>
            import(
            /* webpackChunkName: "rnp" */ './views/InsPayFail.vue'
            )
        },
        {
          path: 'admin',
          name: 'admin',
          component: () => import(/* webpackChunkName: "main" */ '@/views/InsAdmin.vue')
        },
        {
          path: '/event/list/:date',
          name: 'eventList',
          component: () =>
            import(
            /* webpackChunkName: "rnp" */ './views/eventList.vue'
            )
        },
        {
          path: '/event/detail/:id',
          name: 'eventDetail',
          component: () =>
            import(
            /* webpackChunkName: "rnp" */ './views/eventDetail.vue'
            )
        },
        {
          path: '/photo/album',
          name: 'photoAlbum',
          component: () =>
            import(
            /* webpackChunkName: "rnp" */ './views/photoAlbum.vue'
            )
        },
        {
          path: '/photo/list/:id',
          name: 'photoList',
          component: () =>
            import(
            /* webpackChunkName: "rnp" */ './views/photoListN.vue'
            )
        }
      ]
    },
    // 名片
    {
      path: '',
      component: VcardLayout,
      children: [
        {
          path: '/:key',
          name: 'flashlink',
          component: () => import('@/views/flashlink.vue')
        }
      ]
    }
  ]
});

export default router;

router.beforeEach((to, from, next) => {
  if (to.matched.length === 0) { // 如果未匹配到路由
    // SEO判斷處理
    let lang = to.path.toLowerCase().match(/\/en|\/xc|\/tc/i);

    if (lang) {
      let transLang;
      switch (lang[0]) {
        case '/en':
          transLang = 'E';
          break;
        case '/xc':
          transLang = 'S';
          break;
        case '/tc':
          transLang = 'C';
          break;
      }

      i18n.locale = transLang;

      next({
        path: to.path.toLowerCase().replace(lang[0], '')
      });
    } else {
      from.name ? next({ name: from.name }) : next('/'); // 如果上級也未匹配到路由則跳轉首頁，如果上級能匹配到則轉上級路由
    }
  }
  // 標記是從列表頁跳轉產品詳情頁的，方便返回時判斷
  if (from.name === 'productSearch' && to.name === 'ProductsDetail') {
    store.commit('setFromDetail', true);
        console.log(store.state.fromDetail,'store000')
    from.meta!.savedPosition = document.documentElement.scrollTop || document.body.scrollTop;
  }

    // 標記是從列表頁跳轉產品詳情頁的，方便返回時判斷
  if (from.name) {
    Vue.prototype.$ShowLayer();
    setTimeout(() => {
      Vue.prototype.$HiddenLayer();
    }, 500);
  }
  setTimeout(function () {
    if (to.path === '/account/login') {
      if (storage.get('isLogin')) {
        next({ path: '/home' });
      }
      next();
    } else {
      if (to.matched.length === 0) {
        next('/'); // 判断此跳转路由的来源路由是否存在，存在的情况跳转到来源路由，否则跳转到首页
      }
      next(); // 如果匹配到正确跳转
      if (to.matched.some(record => record.meta.requiresAuth) && !storage.get('isLogin')) {
        // router.push({ path: '/account/login' });
        next({
          path: '/account/login',
          query: {
            returnurl: to.path
          }
        });
      } else if (to.matched.some(record => record.meta.requiresAuth) && storage.get('timeout') && storage.get('timeout') < new Date().getTime()) {
        Vue.prototype.$Login(function () { next(); });
      } else {
        next();
      }
    }
  }, 200);
});
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.onlyFrom)) {
    if ((to as any).meta.onlyFrom === from.path) next();
    else next((to as any).meta.onlyFrom);
  } else {
    next();
  }
});



/**
 * 目前蒙层已经不会自动关闭，请在页面适当的时机自行打开。this.$HiddenLayer();
 */
/**
 * 目前所有路由均被拦截加上蒙层，防止页面抖动过大，有需要的小伙伴可以调用：this.$HiddenLayer()，在你觉得合适的时机关闭蒙层（目前我在本文档的159行设置计时器2秒后关闭蒙层）。
 * 如遇ts检测this.$HiddenLayer报找不到改属性或变量，请直接调用Vue.prototype.$HiddenLayer()。其实二者是相同的，但是TS貌似检测不到对象的原型，所以报错。
 * 关于layer配置在./init.ts上，如有需要可以自行修改，或者一起讨论如何修改。
 * */
